import { render, staticRenderFns } from "./promotionLabelLists.vue?vue&type=template&id=565620e7&scoped=true&"
import script from "./promotionLabelLists.vue?vue&type=script&lang=js&"
export * from "./promotionLabelLists.vue?vue&type=script&lang=js&"
import style0 from "./promotionLabelLists.vue?vue&type=style&index=0&id=565620e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565620e7",
  null
  
)

export default component.exports